import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Job } from '../models/job.model';
import { CreateJobRequest } from '../models/create-job.model';
import { UpdateJobStatusRequest } from '../models/update-job-status.model';
import { TaskLog } from '../models/task-log.model';
import { environment } from 'src/app/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class JobService {

  // ✅ Use environment.apiUrl
  private baseUrl = `${environment.apiUrl}/api/jobs`;
  private taskLogsUrl = `${environment.apiUrl}/api/tasklogs`;  // ✅ updated

  constructor(private http: HttpClient) {}

  getJobs(): Observable<Job[]> {
    return this.http.get<Job[]>(this.baseUrl);
  }

  createJob(request: CreateJobRequest): Observable<Job> {
    return this.http.post<Job>(this.baseUrl, request);
  }

  updateJobStatus(id: string, request: UpdateJobStatusRequest) {
    return this.http.put(`${this.baseUrl}/${id}/status`, request);
  }

  deleteJob(id: string) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  // ✅ Fixed URL — was api/jobs/{id}/logs, now api/tasklogs/job/{id}
  getJobLogs(jobId: string): Observable<TaskLog[]> {
    return this.http.get<TaskLog[]>(`${this.taskLogsUrl}/job/${jobId}`);
  }

  assignWorker(jobId: string, userId: string): Observable<Job> {
    return this.http.put<Job>(
      `${this.baseUrl}/${jobId}/assign`,
      { userId }
    );
  }
}